import { Service } from '@tino-frontend/adapters'
import {
  ContractData,
  NextBusinessDayResponse,
  PaymentReservationRequest,
  PaymentReservationResponse,
  PendingTermsResponse,
  PhoneResponse,
  PurchaseIntentionResponse,
  CreateRegister,
  CreateRegisterResponse,
  Term,
} from '@types'

export class CheckoutService {
  constructor(
    private readonly http: Service,
    private readonly authHttp: Service,
    private readonly storage: Service
  ) {
    this.http = http
    this.authHttp = authHttp
    this.storage = storage
  }

  getParams() {
    const value = localStorage.getItem('@true-application/checkout')
    return value ? JSON.parse(value) : undefined
  }

  setParams(
    payload: PaymentReservationRequest & { contracts: ContractData[] }
  ) {
    this.storage.post('@true-application/checkout', payload)
  }

  updateParams(payload: Partial<PaymentReservationRequest>) {
    const params = this.getParams()

    this.deleteParams()

    this.setParams({ ...params.data, ...payload })
  }

  deleteParams() {
    localStorage.removeItem('@true-application/checkout')
  }

  setCustomHeaders(traceId: string) {
    this.http.setInterceptorRequestHeaders((config: any) => ({
      ...config,
      headers: {
        ...config.headers,
        'x-trace-id': traceId,
      },
    }))
  }

  getPendingTerms(purchaseIntentionId: string): Promise<PendingTermsResponse> {
    return this.http
      .get<unknown, Term[]>(`/purchase-intentions/${purchaseIntentionId}/terms`)
      .then((terms) => ({ terms }))
  }

  reservePayment(
    payload: PaymentReservationRequest
  ): Promise<PaymentReservationResponse> {
    return this.http.post('/v2/order/reservation', payload)
  }

  getPurchaseIntention(id: string): Promise<PurchaseIntentionResponse> {
    return this.http.get(`/purchase-intentions/${id}`)
  }

  getNextBusinessDay(): Promise<NextBusinessDayResponse> {
    return this.http.get('/next-business-day')
  }

  getPhones(merchantDocumentNumber: string): Promise<PhoneResponse[]> {
    return this.http.get(`/merchants/${merchantDocumentNumber}/contacts`)
  }

  sendOtp(userId: string) {
    return this.authHttp.post('/v1/validate/whatsapp/otp', { id: userId })
  }

  createRegister(payload: CreateRegister): Promise<CreateRegisterResponse> {
    return this.http.post('/create-soft-register', payload)
  }
}
